import { apiFetch } from "./client.ts";

export interface Approval {
  id: string;
  workflowRunId: string | null;
  stepRunId: string | null;
  approvalType: string;
  title: string;
  description: string | null;
  payload: unknown;
  correlationId: string;
  requestedBy: string | null;
  reviewedBy: string | null;
  status: string;
  reviewNote: string | null;
  expiresAt: string | null;
  createdAt: string;
  reviewedAt: string | null;
}

export async function listApprovals(
  token: string,
  params: { status?: string; approvalType?: string; limit?: number } = {},
): Promise<Approval[]> {
  const qs = new URLSearchParams();
  if (params.status) qs.set("status", params.status);
  if (params.approvalType) qs.set("approvalType", params.approvalType);
  if (params.limit) qs.set("limit", String(params.limit));
  const query = qs.toString() ? `?${qs.toString()}` : "";
  return apiFetch<Approval[]>(`/api/v1/approvals${query}`, { token });
}

export async function getApproval(token: string, id: string): Promise<Approval> {
  return apiFetch<Approval>(`/api/v1/approvals/${id}`, { token });
}

export async function approveRequest(token: string, id: string, note?: string): Promise<void> {
  await apiFetch(`/api/v1/approvals/${id}/approve`, {
    method: "POST",
    token,
    body: JSON.stringify({ note }),
  });
}

export async function rejectRequest(token: string, id: string, note?: string): Promise<void> {
  await apiFetch(`/api/v1/approvals/${id}/reject`, {
    method: "POST",
    token,
    body: JSON.stringify({ note }),
  });
}
